import { Component, Input } from '@angular/core';
import { GaService } from  "../../common/services/ga.service";

@Component({
  selector: 'desktop-search-results',
  templateUrl: './desktop-search-results.component.html',
  styleUrls: ['./desktop-search-results.component.css']
})
export class DesktopSearchResultsComponent  {

  @Input() filterResultsBy = "";
  @Input() searchResult = "";
  constructor(private gaService: GaService) { }

  addToGA(profileName,type,isMember){
    this.gaService.addSearchResultClick(profileName,type,isMember);
  }

  addToGAPerson(profileName,type){
    this.gaService.addPersonSearchResultClick(profileName, type);
  }


}



// WEBPACK FOOTER //
// ./src/app/search/desktop-search-results/desktop-search-results.component.ts